export const redirects = [
    {
        from: "/cal",
        to: "https://calendly.com/imjosh_in",
    },
];
